import classnames from 'classnames';
import PropTypes from 'prop-types';
import { cloneElement } from 'react';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var StoryMainPanel = function StoryMainPanel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      activeSection = _ref.activeSection,
      sidePanelRef = _ref.sidePanelRef,
      panelLayout = _ref.panelLayout,
      theme = _ref.theme,
      noSidePanel = _ref.noSidePanel;
  var classes = classnames('ptr-StoryMainPanel', {}, 'is-' + panelLayout + '-layout', className);
  var newChildren = children;
  var sidePanelNodes;
  sidePanelRef ? (sidePanelNodes = Array.from(sidePanelRef.current.childNodes), sidePanelNodes.length !== children.length ? ( // The number of showcases in the main panel is different from the number of showcases in side panel
  newChildren = [], sidePanelNodes.forEach(function (node, index) {
    children[index] ? newChildren.push(children[index]) : newChildren.push( /*#__PURE__*/_jsx("div", {}));
  })) : null) : null;
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    style: noSidePanel ? {
      width: '100%'
    } : {},
    children: /*#__PURE__*/cloneElement(newChildren[activeSection], {
      theme: theme
    })
  });
};

StoryMainPanel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  activeSection: PropTypes.number,
  sidePanelRef: PropTypes.object,
  panelLayout: PropTypes.string,
  theme: PropTypes.string,
  noSidePanel: PropTypes.bool
};
export default StoryMainPanel;